import { Row, Spin } from 'antd'
import Tooltip from 'app/components/Core/Project/Tooltip'
import GoogleMap from 'app/components/Modules/Map/Map'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useIndex } from 'app/lib/hooks/useApi'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { useEffect } from 'react'
import * as React from 'react'

const Map: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const {
    response: { data },
    execute,
    loading
  } = useIndex<IProject>('Project')

  useEffect(() => {
    execute({ per_page: 150 })
  }, [])

  return (
    <Row>
      <KCol card title={title} span={24}>
        <Spin spinning={loading}>
          <GoogleMap<IProject>
            tooltip={(project) => (
              <Row style={{ maxWidth: 400 }}>
                <KCol span={24}>
                  <Tooltip member={project} />
                </KCol>
              </Row>
            )}
            collection={data.filter(Boolean)}
          />
        </Spin>
      </KCol>
    </Row>
  )
}

export default Map
